// component
import SvgColor from '../../../components/svg-color';
import Nav from "./index";
import {useState} from "react";

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

let navConfig = [];
function fillNav(userData) {
  const roles = localStorage.getItem("roles")?.split(',') ?? [];
  
  function isRole(name) {
    return roles.find((item) => item === name) !== undefined;
  }
  
  const isEmployee = isRole('employee');
  const isFaculty = isRole('faculty');
  const isChair = isRole('chair');
  const isUmu = isRole('AttNewUmu');
  const isMfc = isRole('AttNewMfc');
  const isDispatcher = isRole('AttNewDispatcher');
  const isAdmin  = isRole('AttNewAdmin');
  const medicalCommissionManagement = userData?.userFlags?.medicalCommissionManagement;
  const chairHasVirtualGroups = userData?.userFlags?.virtualGroupEnabled && isChair;
  
  navConfig = [];
  
  if (isMfc) {
    navConfig.push({
      title: 'Карточка студента',
      path: '/search-student',
      icon: icon('ic_student'),
    });
  }
  
  if (isUmu) {
    navConfig.push({
      title: 'Учебно-методическое упр.',
      path: '/umu-main',
      icon: icon('ic_analytics'),
    });

      navConfig.push({
          title: 'Аттестации (УМУ)',
          path: '/attestations-umu',
          icon: icon('ic_analytics'),
      });
    
    if (!isFaculty) {
      navConfig.push({
        title: 'Дашборд',
        path: '/dashboard-page',
        icon: icon('ic_analytics'),
      });
      
      navConfig.push({
        title: 'Карточка студента',
        path: '/search-student',
        icon: icon('ic_student'),
      });
      
      navConfig.push({
        title: 'Практики',
        path: '/faculty-practices-courses',
        icon: icon('ic_practices'),
      });
    }
  }

  if (isDispatcher) {
    navConfig.push({
      title: 'Диспетчерская',
      path: '/umu-main',
      icon: icon('ic_analytics'),
    });
  }

  if (isEmployee) {
    // navConfig.push({
    //   title: 'Главная',
    //   path: '/app',
    //   icon: icon('ic_analytics'),
    // });

    navConfig.push({
      title: 'Журнал',
      path: '/journalmainold',
      icon: icon('ic_user'),
    });

    navConfig.push({
      title: 'Аттестации',
      path: '/attestations',
      icon: icon('ic_analytics')
    });

    navConfig.push({
      title: 'Мои ведомости',
      path: '/mystatements',
      icon: icon('ic_academy'),
    });

    navConfig.push({
      title: 'Практики',
      path: '/my-practice-statements',
      icon: icon('ic_practices'),
    });
  }

  if (isFaculty) {
    navConfig.push({
      title: 'Журнал',
      path: '/journalmainold',
      icon: icon('ic_journal'),
    });

    navConfig.push({
      title: 'Аттестации',
      path: '/facultyattestations',
      icon: icon('ic_analytics'),
    });

    navConfig.push({
      title: 'Сессии',
      path: '/sessions',
      icon: icon('ic_academy'),
    });

    navConfig.push({
      title: 'Практики',
      path: '/faculty-practices-courses',
      icon: icon('ic_practices'),
    });

    navConfig.push({
      title: 'Карточка студента',
      path: '/search-student',
      icon: icon('ic_student'),
    });

    navConfig.push({
      title: 'Карточка группы',
      path: '/group-card',
      icon: icon('ic_academic_group'),
    });

    navConfig.push({
      title: 'Документы',
      path: '/documents',
      icon: icon('ic_document'),
    });

    navConfig.push({
      title: 'Отчёты',
      path: '/reports-list',
      icon: icon('ic_reports'),
    });
    
    navConfig.push({
      title: 'Логины студентов',
      path: '/students-accounts',
      icon: icon('ic_key'),
    });
    
    navConfig.push({
      title: 'Дашборд',
      path: '/dashboard-page',
      icon: icon('ic_analytics'),
    });
  }

  if (isChair) {
    navConfig.push({
      title: 'Журнал',
      path: '/journalmainold',
      icon: icon('ic_journal'),
    });

    navConfig.push({
      title: 'Кураторы',
      path: '/curators',
      icon: icon('ic_curator'),
    });
    
    if (medicalCommissionManagement) {
      navConfig.push({
       title: 'Допуски по мед. комиссии',
       path: '/medical-commission',
       icon: icon('ic_medical'),
      });
    }
    
    if (chairHasVirtualGroups) {
      navConfig.push({
        title: 'Студенты без свод. группы',
        path: '/students-without-virtual-group',
        icon: icon('ic_group'),
      });

      navConfig.push({
        title: 'Поиск свод. гр. студента',
        path: '/find-student-virtual-group',
        icon: icon('ic_search'),
      });
    }
  }

  if (isAdmin) {
    navConfig.push({
      title: 'Админ-панель',
      path: '/admin-panel',
      icon: icon('ic_admin'),
    });
  }

  if (userData?.statementRegistryAvailable === true) {
    navConfig.push({
      title: 'Список ведомостей',
      path: '/statement-registry',
      icon: icon('ic_statements'),
    });
  }
  
  return navConfig;
}

export default fillNav;
